import { render, staticRenderFns } from "./ContactsSearch.vue?vue&type=template&id=2f8dfedc&scoped=true&"
import script from "./ContactsSearch.vue?vue&type=script&lang=ts&"
export * from "./ContactsSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ContactsSearch.vue?vue&type=style&index=0&id=2f8dfedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8dfedc",
  null
  
)

export default component.exports